
export default class API {
    static apiUrl = null;
    static cache = {};
    static currentPageId = '';
    static resources = {};

    static configureResources(resources) {
      this.resources = { ...resources };
    }

    static resourceUrl(resourceKey, id = '') {
      const resource = this.resources[resourceKey];
      if (!resource) {
        throw new Error(`Unknown API resource "${resourceKey}"`);
      }

      const path = resource.path;
      const base = `${resource.baseUrl}/${Translations.langCode}/${path}`;
      return id ? `${base}/${id}` : base;
    }

    static invalidateCache(path) {
      console.log('path', path);
      const pattern = new RegExp(`${path}`);
      for (const key of Object.keys(this.cache)) {
        console.log('pattern', pattern);
        if (pattern.test(key)) {
          delete this.cache[key];
        }
      }
    }

    static async get(url) {
        let pageId = this.currentPageId; // store page id at start of fetch

        await Auth.ensureSuiteBootstrap();

        // see if we have a cached copy of the data. we need a way to invalidate it after an update to an item.
        if (this.cache[url]) {
          return this.cache[url]['response'];
        }

        const accessToken = await Auth.getValidAccessToken();

        const response = await fetch(url, {
          headers: { "authorization": "Bearer " + accessToken },
          method: "GET"
        });

        if (!response.ok) {
          let payload = {};
          try {
            payload = await response.json();
          } catch (error) {
            payload = {};
          }
          const requestError = new Error(payload.message || `Request failed (${response.status})`);
          requestError.status = response.status;
          throw requestError;
        }
        if (pageId !== this.currentPageId) return;

        const data = await response.json();
        this.cache[url] = { response: data };
        return data;
    }

    static async post(url, payload = {}) {
        await Auth.ensureSuiteBootstrap();
        const accessToken = await Auth.getValidAccessToken();

        const response = await fetch(url, {
          headers: {
            "authorization": "Bearer " + accessToken,
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          method: "POST",
          body: JSON.stringify(payload)
        });

        let data = {};
        try {
          data = await response.json();
        } catch (error) {
          data = {};
        }

        if (!response.ok || data.success === false) {
          throw new Error(data.message || `Request failed (${response.status})`);
        }

        return data;
    }
}
